(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pg-beauty-game-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPopup(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var configNode = root.querySelector('[data-pg-popup-config]');
    var config = {};
    try { config = JSON.parse(configNode ? configNode.textContent : '{}'); } catch (e) {}

    var isDesignMode = root.dataset.designMode === 'true';
    var enabled = root.dataset.enabled === 'true';
    var repeatDays = Math.max(0, parseInt(root.dataset.repeatDays || '7', 10));
    var storageKey = 'pg_game_popup_' + root.dataset.sectionId;
    var game = root.dataset.game;
    var hasRevealed = false;

    function setStep(name) {
      root.querySelectorAll('[data-step]').forEach(function (step) {
        step.classList.toggle('is-active', step.dataset.step === name);
      });
    }

    function openPopup() {
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (game === 'scratch') requestAnimationFrame(setupScratch);
    }

    function closePopup() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      if (!isDesignMode) {
        try { localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
      }
    }

    function shouldShow() {
      if (isDesignMode) return true;
      if (!enabled) return false;
      try {
        var last = parseInt(localStorage.getItem(storageKey) || '0', 10);
        if (!last) return true;
        return Date.now() - last >= repeatDays * 86400000;
      } catch (e) { return true; }
    }

    function revealReward() {
      if (hasRevealed) return;
      hasRevealed = true;
      window.setTimeout(function () { setStep('claim'); }, 220);
    }

    root.querySelectorAll('[data-close]').forEach(function (button) {
      button.addEventListener('click', closePopup);
    });
    root.querySelectorAll('[data-reveal]').forEach(function (button) {
      button.addEventListener('click', revealReward);
    });

    function setupScratch() {
      var canvas = root.querySelector('[data-scratch-canvas]');
      var wrap = root.querySelector('[data-scratch-wrap]');
      if (!canvas || !wrap) return;

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var rect = wrap.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      var ctx = canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      function fillFallback() {
        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = config.scratchFallback || '#d5aa92';
        ctx.fillRect(0, 0, rect.width, rect.height);
        ctx.globalAlpha = .18;
        for (var i = 0; i < 11; i++) {
          ctx.beginPath();
          ctx.strokeStyle = '#ffffff';
          ctx.lineWidth = 8 + (i % 3) * 5;
          ctx.moveTo(-20, 20 + i * 18);
          ctx.bezierCurveTo(rect.width * .25, i * 11, rect.width * .68, 40 + i * 14, rect.width + 20, 10 + i * 17);
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }

      fillFallback();
      if (config.scratchImage) {
        var img = new Image();
        img.onload = function () {
          ctx.globalCompositeOperation = 'source-over';
          ctx.clearRect(0, 0, rect.width, rect.height);
          var scale = Math.max(rect.width / img.width, rect.height / img.height);
          var w = img.width * scale;
          var h = img.height * scale;
          ctx.drawImage(img, (rect.width - w) / 2, (rect.height - h) / 2, w, h);
        };
        img.onerror = fillFallback;
        img.src = config.scratchImage;
      }

      var scratching = false;
      var distance = 0;
      var threshold = Math.max(10, Math.min(90, parseInt(root.dataset.scratchThreshold || '35', 10)));
      var targetDistance = (rect.width * rect.height) * (threshold / 100) / 18;
      var lastPoint = null;

      function scratchAt(x, y) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath();
        ctx.arc(x, y, Math.max(20, Math.min(rect.width, rect.height) * .12), 0, Math.PI * 2);
        ctx.fill();
        if (lastPoint) distance += Math.hypot(x - lastPoint.x, y - lastPoint.y);
        lastPoint = { x: x, y: y };
        if (distance >= targetDistance) revealReward();
      }

      canvas.addEventListener('pointerdown', function (event) {
        scratching = true;
        canvas.setPointerCapture(event.pointerId);
        var r = canvas.getBoundingClientRect();
        scratchAt(event.clientX - r.left, event.clientY - r.top);
      });
      canvas.addEventListener('pointermove', function (event) {
        if (!scratching) return;
        var r = canvas.getBoundingClientRect();
        scratchAt(event.clientX - r.left, event.clientY - r.top);
      });
      canvas.addEventListener('pointerup', function () { scratching = false; lastPoint = null; });
      canvas.addEventListener('pointercancel', function () { scratching = false; lastPoint = null; });
    }

    function validEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    async function subscribeKlaviyo(email) {
      var siteId = root.dataset.klaviyoSiteId;
      var listId = root.dataset.klaviyoListId;
      if (!siteId) throw new Error('Missing Klaviyo Site ID');
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  properties: { 'PG Beauty Signup Source': config.source || 'Game Popup', 'PG Beauty Game': game }
                }
              }
            },
            custom_source: config.source || 'PG Beauty Game Popup'
          }
        }
      };
      if (listId) payload.data.relationships = { list: { data: { type: 'list', id: listId } } };
      var response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(siteId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2026-07-15' },
        body: JSON.stringify(payload)
      });
      if (!response.ok && response.status !== 202) throw new Error('Klaviyo signup failed');
    }

    async function subscribeShopify(email) {
      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[email]', email);
      body.set('contact[tags]', 'newsletter,pg-game-popup');
      var response = await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body.toString(),
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Signup failed');
    }

    var form = root.querySelector('[data-email-form]');
    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var error = form.querySelector('[data-error]');
        var button = form.querySelector('button[type="submit"]');
        var email = input ? input.value.trim() : '';
        if (error) error.hidden = true;
        if (!validEmail(email)) {
          if (error) error.hidden = false;
          if (input) input.focus();
          return;
        }
        button.disabled = true;
        try {
          var provider = root.dataset.provider;
          if (provider === 'klaviyo') await subscribeKlaviyo(email);
          else if (provider === 'shopify' || provider === 'omnisend') await subscribeShopify(email);
          // test mode intentionally stores nothing.
          setStep('success');
          if (!isDesignMode) {
            try { localStorage.setItem(storageKey, String(Date.now())); } catch (e) {}
          }
        } catch (e) {
          if (error) { error.textContent = e.message || error.textContent; error.hidden = false; }
        } finally {
          button.disabled = false;
        }
      });
    }

    var copyButton = root.querySelector('[data-copy-code]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = copyButton.dataset.code || '';
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(function () { copyButton.textContent = 'COPIED'; });
        }
      });
    }

    if (shouldShow()) {
      var delay = isDesignMode ? 0 : Math.max(0, parseInt(root.dataset.delay || '4', 10)) * 1000;
      window.setTimeout(openPopup, delay);
    }
  }

  document.querySelectorAll('.pg-game-popup').forEach(initPopup);
  document.addEventListener('shopify:section:load', function (event) {
    initPopup(event.target.querySelector('.pg-game-popup'));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
